import { reactive } from 'vue'
import { extend } from '@xzx-design/utils'
import { useExpose } from '../'

export function usePopupState() {
  const state = reactive<{
    show: boolean
    [key: string]: any
  }>({
    show: false,
  })

  const toggle = (show: boolean) => {
    state.show = show
  }

  const open = (props: Record<string, any>) => {
    extend(state, props, { transitionAppear: true })
    toggle(true)
  }

  const close = () => toggle(false)

  useExpose({ open, close, toggle })

  return {
    open,
    close,
    state,
    toggle,
  }
}
